export const POST_CATEGORIES_FORM_NAME = 'postCategories';

const POST_CATEGORIES_FORM_CONFIG = {
  formName: POST_CATEGORIES_FORM_NAME,
  fields: ['categoryIds'],
  resetOnUnmount: true,
};

export default POST_CATEGORIES_FORM_CONFIG;
